import {
    Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container,
    Card, CardBody, CardTitle, CardFooter
} from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReporteDespachoTable from "./ReporteDespachoTable"
import ReporteDespachoService from "./ReporteDespachoService"
import ReporteDespachoBananoService from "./ReporteDespachoBananoService"
import ReporteDespachoMultiproductoService from "./ReporteDespachoMultiproductoService"
import { SemanasView } from "./SemanasView"
import { SemanasDelete } from "./SemanasDelete"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { default as MuiInput } from '@mui/material/Input';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import { ReporteDespachoChart } from "./ReporteDespachoChart"

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'
import General from '../General/General'

export class ReporteDespacho_Index extends Component {
    static displayName = ReporteDespacho_Index.name;
    constructor(props) {
        super(props);
        var today = new Date();
        var week = today.getWeek().toString();
        var year = today.getFullYear().toString();
        this.state = {
            data: [],
            yearData:[],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { nombre: "", week: week, year: year, destinos: [] },
            destinos: [],
        };
        this.load_destinos = this.load_destinos.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
        this.printReport = this.printReport.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    ITEM_HEIGHT = 48;
    ITEM_PADDING_TOP = 8;
    MenuProps = {
        PaperProps: {
            style: {
                maxHeight: this.ITEM_HEIGHT * 4.5 + this.ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    getPaletasTotales = () => {
        return this.state.data.length;
    }
    getCajasTotales = () => {
        const sum = this.state.data.reduce((accumulator, object) => {
            return accumulator + object.cajasPorPaleta;
        }, 0);
        return sum;
    }
    getContenedoresTotales = () => {
        var sum = this.state.data.map((item) => item.contenedor)
            .filter((value, index, self) => self.indexOf(value) === index).length;
/*        var sum = [...new Set(this.state.data.map(item => item.contenedores))].length;*/
        return sum;
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="year">
                                        <FormattedMessage id='Year' />
                                    </Label>
                                    <FormattedMessage id='Year'>
                                        {(placeholder) =>
                                            <Input
                                                id="year"
                                                name="year"
                                                //placeholder={placeholder}
                                                type="number"
                                                onChange={this.handleSearchChange}
                                                value={this.state.searchModel.year}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="week">
                                        <FormattedMessage id='Week' />
                                    </Label>
                                    <FormattedMessage id='Week'>
                                        {(placeholder) =>
                                            <Input
                                                id="week"
                                                name="week"
                                                /*placeholder={placeholder}*/
                                                type="number"
                                                onChange={this.handleSearchChange}
                                                value={this.state.searchModel.week}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormControl sx={{  width: 300 }}>
                                    <Label for="destinos">
                                        <FormattedMessage id='Destinos' />
                                    </Label>
                                    <Select
                                        labelId=""
                                        id="demo-multiple-checkbox"
                                        name="destinos"
                                        multiple
                                        value={this.state.searchModel.destinos}
                                        onChange={this.handleSearchChange}
                                        input={<MuiInput />}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={this.MenuProps}
                                    >
                                        {this.state.destinos.map((nombre) => (
                                            <MenuItem key={nombre} value={nombre}>
                                                <Checkbox checked={this.state.searchModel.destinos.indexOf(nombre) > -1} />
                                                <ListItemText primary={nombre} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="DownloadButton IndexButton" onClick={this.printReport}>
                                        <DownloadOutlinedIcon fontSize='large' /> <FormattedMessage id='Descargar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                            
                        </Row>
                    </Form>
                </Row>
                <Row className="d-flex justify-content-center">
                    <div className="col col-md-3">
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#324a68', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><LocalShippingIcon fontSize="large" style={{ color: '#7387a2' }} /></h1>
                                    <div>
                                        Contenedores
                                        <CardTitle tag="h4">
                                            {this.getContenedoresTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col col-md-3">
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#25675D', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaPallet style={{ color: '#52877D' }} /></h1>
                                    <div>
                                        Paletas
                                        <CardTitle tag="h4">
                                            {this.getPaletasTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col col-md-3">
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#B8895F', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaBoxes style={{ color: '#C6A27E' }} /></h1>
                                    <div>
                                        Cajas
                                        <CardTitle tag="h4">
                                            {this.getCajasTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Row>
                <Row>
                    <ReporteDespachoChart data={this.state.data }/>
                </Row>
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/ReporteDespacho", message: "FlujoDeTrabajo", active: true },
                { link: "/ReporteDespacho", message: "Reporte de despacho", active: false },
            ]} />;

        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div>
                <h2><FormattedMessage id='Reporte de despacho' /></h2>
                {breadcrumbsData}
                
                <div className="viewContainer">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true, destinos: await this.load_destinos() }, async () => {
            const token = await authService.getAccessToken();
            var queryString = '?';
            Object.keys(this.state.searchModel).forEach(key => {
                let value = this.state.searchModel[key];
                if (key == "destinos") {
                    value = this.state.searchModel[key].join(';')
                    if (value == "") {
                        value = "none"
                    }
                }
                queryString += key + "=" + value + "&";
            });
            queryString = queryString.slice(0, -1);
            const response = await fetch('api/reporteDespacho' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            this.setState({ data: responceData, loading: false });
        });
    }

    handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        var value = event.target.value;
        if (event.target.name == "destinos") {
            value = typeof value === 'string' ? value.split(',') : value;
        }
        searchModel[event.target.name] = value
        this.setState({ searchModel: searchModel }, async () => {
            if (event.target.name == "year" || event.target.name == "week") {
                this.setState({
                    destinos: await this.load_destinos()
                });
            }
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><SemanasView setModalBodyState={this.setModalBodyState}></SemanasView></div>);
        //return (<div><SemanasView ref={this.modalBodyState}></SemanasView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/semanas', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><SemanasView setModalBodyState={this.setModalBodyState} data={responceData}></SemanasView></div>);
        //return (<div><SemanasView ref={this.modalBodyState}></SemanasView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/semanas/' + this.modalBodyState.semana_Id, {
            method: 'PUT',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><SemanasDelete setModalBodyState={this.setModalBodyState} data={responceData}></SemanasDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + this.modalBodyState.semana_Id, {
            method: 'DELETE',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        var today = new Date();
        var week = today.getWeek().toString();
        var year = today.getFullYear().toString();
        this.setState({
            searchModel: { nombre: "", week: week, year: year, destinos: [] }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }

    async load_destinos() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/reporteDespacho/destinos?year=' + this.state.searchModel.year + '&week=' + this.state.searchModel.week, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }

    async printReport() {
        this.setState({
            loading: true
        }, async () => {
            var usuario = await new General().getUsuario();
            //console.log("usuario", usuario)

            var destinos = this.state.searchModel['destinos'].join(';')
            if (destinos == "") {
                destinos = "none"
            }
            if (usuario.producto == "Piña") {
                await new ReporteDespachoService().ReporteDespacho(this.state.searchModel.year, this.state.searchModel.week, destinos);
            }
            else if (usuario.producto == "Banano") {
                await new ReporteDespachoBananoService().ReporteDespacho(this.state.searchModel.year, this.state.searchModel.week, destinos);
            }
            else if(usuario.producto == "Multiproducto") {
                await new ReporteDespachoMultiproductoService().ReporteDespacho(this.state.searchModel.year, this.state.searchModel.week, destinos);
            }
            this.setState({
                loading: false
            });
        })
    }
}